<template>
  <div>
    <div class="row mb-1 text-medium">
      <div class="col-4">
        Data Center
      </div>
      <div class="col-4">
        Status
      </div>
      <div class="col-4">
        Last checked
      </div>
    </div>
    <div
      v-for="(item, index) in logs"
      :key="`log${index}`"
      class="row align-items-center"
    >
      <div class="col-4">
        <div class="d-flex">
          <img
            :src="item.dataCenter.imageUrl"
            alt="flag"
            class="tag-img"
          >
          <div class="ml-1">
            <div class="text-medium">
              {{ item.dataCenter.name }}
            </div>
            <span class="text-xsm">{{ item.dataCenter.slug }}</span>
          </div>
        </div>
      </div>
      <div class="col-4">
        <b-badge
          :variant="item.isHealthy ? 'light-success' : 'light-danger'"
          class="text-sm"
        >
          {{ item.isHealthy ? 'Healthy' : 'Unhealthy' }}
        </b-badge>
      </div>
      <div class="col-4">
        <template v-if="formatTime">
          {{ item.healthcheckLogId ? `${timeSince(item.executedAt)} ago` : '-' }}
        </template>
        <template v-else>
          {{ item.executedAt }}
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StatusLogList',
  props: {
    logs: {
      type: Array,
      required: true,
    },
    formatTime: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.logs-table {
  margin: 16px 0;
  ::v-deep {
    thead {
      th {
        background-color: var(--white) !important;
        padding-bottom: 10px;
      }
    }
  }
}
.tag-img {
  width: 20px;
  height: 15px;
  box-shadow: 2px 2px 8px 1px rgb(0 0 0 / 50%);
  transform: translateY(-5px);
  margin-top: 16px;
}
</style>
